module.exports = __webpack_public_path__ + "img/saks7.dd30a875.jpg";